enum PermissionsEnum {
  VIEW_VEHICLES_IN_PDI = 'view_vehicles_in_pdi',
  EDIT_VEHICLES_IN_PDI = 'edit_vehicles_in_pdi',
  EXPORT_VEHICLES_IN_PDI = 'export_vehicles_in_pdi',
  VIEW_LAST_MILE_TRACK = 'view_last_mile_track',
  EDIT_LAST_MILE_TRACK = 'edit_last_mile_track',
  EXPORT_LAST_MILE_TRACK = 'export_last_mile_track',
  VIEW_VEHICLE_MONITORING = 'view_vehicle_monitoring',
  EDIT_VEHICLE_MONITORING = 'edit_vehicle_monitoring',
  EXPORT_VEHICLE_MONITORING = 'export_vehicle_monitoring',
  VIEW_DISPATCHED_REPORT = 'view_dispatched_report',
  EDIT_DISPATCHED_REPORT = 'edit_dispatched_report',
  EXPORT_DISPATCHED_REPORT = 'export_dispatched_report',
  VIEW_REQUESTS = 'view_requests',
  EDIT_REQUESTS = 'edit_requests',
  EXPORT_REQUESTS = 'export_requests',
  VIEW_OPERATIONAL_METRICS = 'view_operational_metrics',  
  EDIT_OPERATIONAL_METRICS = 'edit_operational_metrics',
  EXPORT_OPERATIONAL_METRICS = 'export_operational_metrics',
  VIEW_INVENTORY = 'view_inventory',
  EDIT_INVENTORY = 'edit_inventory',
  EXPORT_INVENTORY = 'export_inventory',
  VIEW_CUSTOMERS = 'view_customers',
  EDIT_CUSTOMERS = 'edit_customers',
  EXPORT_CUSTOMERS = 'export_customers',
  VIEW_TEAM = 'view_team',
  EDIT_TEAM = 'edit_team',
  EXPORT_TEAM = 'export_team',
  VIEW_MANAGE_REVIEWS = 'view_manage_reviews',
  VIEW_GROUP_ROUTE = 'view_group',
  EDIT_GROUP_ROUTE = 'edit_group',
}

export default PermissionsEnum;
